import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { Batch } from "@/types/dashboard.types";

interface ReviewState {
  editedBatch: Batch | null;
  reviewedDocumentIds: string[];
  setEditedBatch: (batch: Batch) => void;
  markAsReviewed: (documentId: string) => void;
  isReviewed: (documentId: string) => boolean;
}

export const useReviewStore = create<ReviewState>()(
  persist(
    (set, get) => ({
      editedBatch: null,
      reviewedDocumentIds: [],
      setEditedBatch: (batch) => set({ editedBatch: batch }),
      markAsReviewed: (documentId) =>
        set((state) => ({
          reviewedDocumentIds: [...state.reviewedDocumentIds, documentId],
        })),
      isReviewed: (documentId) => {
        return get().reviewedDocumentIds.includes(documentId);
      },
    }),
    {
      name: "review-storage",
      storage: createJSONStorage(() => localStorage),
    }
  )
);
